import I18n from 'lib/i18n'

import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import FileIcon, { defaultStyles } from 'react-file-icon'

import Spinner from 'lib/tags/spinner'

const whiteStyles = { color: 'white' }

const Attachments = ({ attachments, removeAttachment, custom }) => {
  if (!attachments || attachments.length === 0) {
    return null
  }

  const customStyles = custom === 'white' ? whiteStyles : {}

  return (
    <ol className='attached-files'>
      {attachments.map(attachment => (
        <li key={attachment.id}>
          <div className='attachment'>
            <FileIcon
              size={24}
              extension={attachment.extension}
              {...customStyles}
              {...(attachment.extension ? defaultStyles[attachment.extension] : {})}
            />

            <a href={attachment.path} target='_blank' className='attachment-filename' rel='noreferrer'>
              {attachment.filename}
            </a>

            {removeAttachment && (
              <span className='remove-attachment'>
                {attachment.isRemoving ? (
                  <Spinner />
                ) : (
                  <span className='remove-link' onClick={() => removeAttachment(attachment.id)}>
                    {I18n.t('messages.show_thread.attachment_remove')}
                  </span>
                )}
              </span>
            )}
          </div>
        </li>
      ))}
    </ol>
  )
}

Attachments.propTypes = {
  attachments: PropTypes.array,
  removeAttachment: PropTypes.func,
  custom: PropTypes.string
}

export default Attachments
